/* eslint-disable comma-dangle */
/* eslint-disable semi */
/* eslint-disable quotes */
import { api, Api } from "../../services/api";
import { IAuthDataHandler } from "./IAuthDataHandler";

export class AuthApiDataHandler implements IAuthDataHandler {
  api: Api;
  _apiKey: string | null;

  constructor() {
    this.api = api;
    this._apiKey = null;
  }

  setAuth(token: string) {
    this.api.client.defaults.headers.common.Authorization = `Basic ${btoa(token)}`;
  }

  setXToken(token: string) {
    this.api.client.defaults.headers.common["X-Token"] = token;
  }

  async requestAuth(
    email: string,
    password: string,
  ): Promise<{ token: string }> {
    const { data } = await this.api.client.post<{ token: string }>(
      "auth_tokens",
      {
        email,
        password,
      },
    );

    return data;
  }
}
